import React from 'react';
import { motion } from 'framer-motion';
export function Closing() {
  return <footer className="w-full bg-[#f3e9dd] px-6 py-20 text-center sm:py-28" data-id="element-26" data-mp="3t0hp4tw29imk">
      <motion.blockquote initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.8
    }} className="mx-auto max-w-2xl" data-id="element-27" data-mp="3t2ltfcxvgjnd">
        <p className="font-serif text-2xl font-medium italic leading-snug text-[#3a2e28] sm:text-3xl" data-id="element-28" data-mp="35a5az1a82pnj">
          “El equilibrio no es la ausencia de tormenta. Es la paz que decides
          sostener en medio de ella.”
        </p>
      </motion.blockquote>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="mx-auto mt-10 max-w-md" data-id="element-29" data-mp="30c3soikmeud4">
        <div className="mx-auto mb-6 h-px w-16 bg-[#c9a24b]" data-id="element-30" data-mp="yl8trhv4af26" />
        <p className="text-sm text-[#7a6a5f]" data-id="element-31" data-mp="yieavurr52av">Con amor,</p>
        <p className="mt-1 font-serif text-lg text-[#8f5238]" data-id="element-32" data-mp="3r0o2rugj9965">
          Liza — Tu Mundo Equilibrado
        </p>
        <p className="mt-4 text-sm italic leading-relaxed text-[#7a6a5f]" data-id="element-33" data-mp="3m2crdfalaqlt">
          Tratando de hacer un mundo más equilibrado desde la ventana de Liza.
        </p>
      </motion.div>
    </footer>;
}